import { ClassProvider } from '@angular/core';

import { Types } from '../../../domain/types.domain';
import { UploadDocumentService } from '../../../domain/representative/services/upload-document.service';

export class UploadDocumentServiceInstruction implements ClassProvider {
  provide = Types.UploadDocumentService;
  deps = [Types.RepresentativeRepository];
  useClass = UploadDocumentService;
}
